import React, { FC } from 'react';
import { Button, Box, DialogContentText } from '@mui/material';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { useTranslation } from 'react-i18next';

type ErrorDialogProps = {
    errorMessage: string;
    extraInfo: { [key: string]: string };
    open: boolean;
    onClose: () => void;
};
const ErrorDialog: FC<ErrorDialogProps> = ({ errorMessage, extraInfo, open, onClose }: ErrorDialogProps) => {
    const { t: translate } = useTranslation(['common']);

    return (
        <DHDialog
            maxWidth="sm"
            fullWidth
            open={open}
            onClose={onClose}
            title={translate('common:AN_ERROR_OCCURRED')}
            actions={
                <Button key="close" onClick={onClose} data-test="error-dialog.close">
                    {translate('common:CLOSE')}
                </Button>
            }
        >
            <DialogContentText id="alert-dialog-description">
                {translate(`common:APOLLO_ERRORS.${errorMessage}`)}
                {extraInfo.userInputRequired ? (
                    <Box>
                        {Object.keys(extraInfo).map((key: keyof typeof extraInfo, index: number) => {
                            if (extraInfo[key] && key !== 'userInputRequired') {
                                return (
                                    <p key={index}>
                                        {translate(key as string)}: {extraInfo[key]}
                                    </p>
                                );
                            }
                        })}
                    </Box>
                ) : (
                    <Box>{translate('common:CONTACT_SUPPORT')}</Box>
                )}
            </DialogContentText>
        </DHDialog>
    );
};

export default ErrorDialog;
